<div class="settings-container">
  <div class="settings-header">
    <h2>Settings</h2>
    <p class="subtitle">Manage your notification preferences</p>
  </div>

  <div class="settings-content">
    <div class="notification-preferences-section">
      <div class="section-header">
        <h3>Notification Preferences</h3>
        <p>Choose which notifications you want to receive via email and in-app.</p>
      </div>

      <div class="bulk-actions">
        <span class="bulk-label">Quick Actions:</span>
        <div class="bulk-buttons">
          <button kendoButton size="small" fillMode="outline" (click)="enableAllEmail()">Enable All Emails</button>
          <button kendoButton size="small" fillMode="outline" (click)="disableAllEmail()">Disable All Emails</button>
          <button kendoButton size="small" fillMode="outline" (click)="enableAllInApp()">Enable All In-App</button>
          <button kendoButton size="small" fillMode="outline" (click)="disableAllInApp()">Disable All In-App</button>
        </div>
      </div>

      <div *ngIf="loading" class="loading-indicator">
        <kendo-loader type="infinite-spinner" size="medium"></kendo-loader>
        <span>Loading preferences...</span>
      </div>

      <div *ngIf="!loading" class="preferences-list">
        <div *ngFor="let group of preferenceGroups" class="preference-group">
          <h4 class="group-title">{{ group.category }}</h4>

          <div *ngFor="let item of group.preferences" class="preference-item">
            <div class="preference-info">
              <span class="preference-name">{{ item.displayName }}</span>
              <span class="preference-description">{{ item.description }}</span>
            </div>

            <div class="preference-toggles">
              <div class="toggle-group">
                <label>Email</label>
                <kendo-switch
                  [(ngModel)]="item.emailEnabled"
                  (valueChange)="onPreferenceChange(item, 'email')"
                  [disabled]="saving"
                ></kendo-switch>
              </div>

              <div class="toggle-group">
                <label>In-App</label>
                <kendo-switch
                  [(ngModel)]="item.inAppEnabled"
                  (valueChange)="onPreferenceChange(item, 'inApp')"
                  [disabled]="saving"
                ></kendo-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
